import React from 'react';
import { SubscriptionActionModalText, SubscriptionActionModalTitle } from '../CancelSubscriptionModal.style';
import { FormattedMessage } from 'react-intl';
import { Spinner } from '@mindly/ui-components';

const LoaderStep = () => {
  return (
    <div className={'loader-wrapper'}>
      <div className={'loader-spinner'}>
        <Spinner />
      </div>
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.cancel.step.3.title'} defaultMessage={'Скасування плану'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText>
        <FormattedMessage id={'general.please.wait'} defaultMessage={'Будь ласка, зачекайте'} />
      </SubscriptionActionModalText>
    </div>
  );
};

export default LoaderStep;
